import { render, staticRenderFns } from "./form-properties.vue?vue&type=template&id=67a6a816&"
import script from "./form-properties.vue?vue&type=script&lang=js&"
export * from "./form-properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports